import { styled } from "@mui/material"
import { DataGrid as MuiDataGrid } from "@mui/x-data-grid"

import { InfoFrame } from "../InfoFrame"

export const DataGrid = styled(MuiDataGrid)(({ theme }) => ({
    border: "none",
    overflow: "hidden",
    height: "100%",
    flex: 1,
    minHeight: 0,
    "--DataGrid-rowBorderColor": "transparent",

    "& .MuiDataGrid-filler > div": {
        borderTop: "none",
    },

    "& .MuiDataGrid-columnHeaders": {
        position: "relative",

        "&::before": {
            content: "\"\"",
            position: "absolute",
            top: 0,
            left: 0,
            right: "calc(var(--DataGrid-hasScrollY, 0) * 14px)",
            bottom: 0,
            borderRadius: 12,
            backgroundColor: theme.palette["_components/app-bar/button/default"].dark,
        },
    },
    "& .MuiDataGrid-columnHeader": {
        position: "relative",
        backgroundColor: "transparent",

        "&:focus, &:focus-within": {
            outline: "none",
        },
    },
    "& .MuiDataGrid-columnHeaderTitle": {
        color: theme.palette["common/white_states"].main,
        fontWeight: 600,
        fontSize: 14,
    },
    "& .MuiDataGrid-sortIcon, & .MuiDataGrid-menuIcon .MuiSvgIcon-root": {
        color: theme.palette["common/white_states"].main,
        width: 24,
        height: 24,
        fontSize: 24,
    },
    "& .MuiDataGrid-iconButtonContainer .MuiIconButton-root": {
        backgroundColor: "transparent",
        padding: 0,
    },
    "& .MuiDataGrid-columnSeparator": {
        display: "none",
    },

    "& .MuiDataGrid-cell": {
        border: "none",
        position: "relative",
        boxSizing: "border-box",
        height: "var(--height)",
        paddingTop: theme.spacing(),

        "&:focus, &:focus-within": {
            outline: "none",
        },
    },
    "& .MuiDataGrid-row": {
        position: "relative",
        boxSizing: "border-box",
        paddingRight: "calc(var(--DataGrid-hasScrollY, 0) * 14px)",

        "&:hover": {
            backgroundColor: "transparent",
        },

        "&::before": {
            content: "\"\"",
            position: "absolute",
            top: theme.spacing(2),
            left: 0,
            right: "calc(var(--DataGrid-hasScrollY, 0) * 14px)",
            bottom: 0,
            borderRadius: 12,
            backgroundColor: theme.palette.secondary.main,
        },
        "&:hover::before": {
            backgroundColor: theme.palette.secondary.dark,
        },
        "&.Mui-selected::before": {
            backgroundColor: theme.palette.secondary.dark,
        },

        "&.L2RTable-row--disabled": {
            opacity: 0.6,
        },
        "&.L2RTable-row--disabled::before": {
            backgroundColor: theme.palette["action/disabled"].main,
        },
        "&.L2RTable-row--disabled:hover::before": {
            backgroundColor: theme.palette["action/disabled"].main,
        },
    },
    "& .MuiDataGrid-virtualScroller": {
        backgroundColor: theme.palette["common/white_states"].main,
    },

    "& .MuiDataGrid-footerContainer": {
        border: "none",
        justifyContent: "center",
        minHeight: "fit-content",
        marginTop: theme.spacing(6),
    },
}))

export const NoRowsOverlay = styled(InfoFrame)(({ theme }) => ({
    marginTop: theme.spacing(2),
    justifyContent: "center",
}))
